import { CommonPageWrapper, HeadingWrapper } from 'admin/components/wrappers';
import AdminCustomButton from 'app/components/AdminCustomButton';
import { AdminSearch } from 'app/components/AdminSearchField';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDebounce } from 'hooks/useDebounce';
import ShowManageRiderTable from './ShowManageRiderTable';
import AdminShowRiderCard from 'app/components/AdminShowRiderCard';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useShowApi from 'admin/hooks/useShowApi';
import AdminMultiSelectDropDown from 'admin/components/AdminMultiSelectDropdown';
import { ShowMangeRiderFilteredData } from 'admin/components/AdminMultiSelectDropdown/FilteredList';
import { getLookupArray } from 'utils/common';
import useCommonLookUpDatas from 'hooks/useCommonLookupData';
import { TableSkeletonLoader } from 'app/components/TableSkeletonLoader';
import { RiderSplitClass } from 'services/openapi';
import { usePermission } from 'hooks/usePermission';
import Cookies from 'js-cookie';

type Props = {
  showName?: string;
};
const ShowManageRider = ({ showName }: Props) => {
  const userType = Cookies.get('userType') ?? '';
  const { id: showId } = useParams();
  const {
    fetchManageGetShowRiderList,
    showRiderDataList,
    loading,
    deleteShowRider,
    updateClassSplitApi,
  } = useShowApi();
  const { getAllLookupData, lookUps } = useCommonLookUpDatas();
  const currentLocation = useLocation();
  const { hasViewPermission } = usePermission();
  const navigate = useNavigate();
  const isPastDataFlag = currentLocation.pathname.includes('past-data');
  const [active, setActive] = useState(true);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [pageSkip, setPageSkip] = useState<number | undefined>(0);
  const debounceShowSearch = useDebounce(searchTerm);
  const [lookupData, setLookupData] = useState('');
  const [divisionIds, setDivisionIds] = useState('');
  const [categoryIds, setCategoryIds] = useState('');
  const divisionIdsArray = divisionIds ? divisionIds.split(',') : [];
  const categoryIdsArray = categoryIds ? categoryIds.split(',') : [];
  const [teamIds, setTeamIds] = useState('');
  const [preDataList, setPreDataList] =
    useState<{ name: string; id: string; type: string }[]>();
  const isTeam = preDataList?.find(item => item.type === 'TEAM');
  const teamIdsArray = teamIds ? teamIds.split(',') : [];
  const teamId = isTeam ? teamIdsArray : [];
  const handleSearch = e => {
    setSearchTerm(e.target.value);
  };
  const handleSaveClick = (requestBody: Array<RiderSplitClass>) => {
    updateClassSplitApi(
      false,
      requestBody,
      showId,
      teamId,
      categoryIdsArray,
      divisionIdsArray,
      debounceShowSearch,
      '',
      0,
      pageSkip,
      10,
      true,
    );
  };
  const handleClassDelete = (showRiderIds: string[]) => {
    showRiderIds.forEach(showRiderId => {
      deleteShowRider(
        showRiderId,
        showId,
        teamId,
        divisionIdsArray,
        categoryIdsArray,
        debounceShowSearch,
        '',
      );
    });
  };
  useEffect(() => {
    if (debounceShowSearch.length > 0) {
      fetchManageGetShowRiderList(
        showId ?? '',
        teamId,
        categoryIdsArray,
        divisionIdsArray,
        debounceShowSearch,
        '',
        0,
        0,
        10,
      );
    } else if (debounceShowSearch.length === 0 && teamId.length === 0) {
      fetchManageGetShowRiderList(
        showId ?? '',
        teamId,
        categoryIdsArray,
        divisionIdsArray,
        debounceShowSearch,
        '',
        0,
        0,
        10,
      );
    } else {
      fetchManageGetShowRiderList(
        showId ?? '',
        teamId,
        categoryIdsArray,
        divisionIdsArray,
        debounceShowSearch,
        '',
        0,
        pageSkip,
        10,
      );
    }

    if (pageSkip !== 0) {
      if (debounceShowSearch?.length >= 0 || teamId.length === 0) {
        setPageSkip(0);
      }
    }
  }, [debounceShowSearch, teamIds, categoryIds, divisionIds]);
  useEffect(() => {
    getAllLookupData(`TEAM,DIVISION,CATEGORY`);
  }, []);
  return (
    <>
      <StyledCommonPageWrapper>
        <HeadingWrapper>
          <ButtonWrapper>
            {hasViewPermission('0500101004') && (
              <>
                {!isPastDataFlag && (
                  <AdminCustomButton
                    buttonType="primary"
                    isActive={false}
                    className="fill-button"
                    onClick={() => {
                      setActive(!active);
                      navigate(
                        userType === 'COACH'
                          ? `/coach/shows/view/${showId}/ManageRider/create/${showName}`
                          : `/admin/shows/view/${showId}/ManageRider/create/${showName}`,
                      );
                    }}
                  >
                    Add Rider
                  </AdminCustomButton>
                )}
              </>
            )}

            <AdminMultiSelectDropDown
              data={ShowMangeRiderFilteredData}
              setLookupData={setLookupData}
              filteredData={getLookupArray(lookupData, lookUps)}
              lookUps={lookUps}
              setTeamIds={setTeamIds}
              lookupData={lookupData}
              setDivisionIds={setDivisionIds}
              setCategoryIds={setCategoryIds}
              setPreDataList={setPreDataList}
              preDataList={preDataList}
            />
          </ButtonWrapper>
          <SearchButtonWrapper>
            {hasViewPermission('0500101008') && (
              <>
                {!isPastDataFlag &&
                  showRiderDataList?.groupedRiders?.length! > 0 && (
                    <AdminCustomButton
                      buttonType="danger"
                      isActive={false}
                      onClick={() => {
                        navigate(
                          userType === 'COACH'
                            ? `/coach/shows/generate-split/${showId}`
                            : `/admin/shows/generate-split/${showId}`,
                        );
                      }}
                    >
                      Generate Split
                    </AdminCustomButton>
                  )}
              </>
            )}

            <div style={{ width: '283px' }}>
              <AdminSearch
                placeholder="Search By Team or Rider"
                onSearchTextEntering={handleSearch}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </SearchButtonWrapper>
        </HeadingWrapper>
        <CardWrapper>
          <AdminShowRiderCard
            title="Riders"
            totalTryitTeams={showRiderDataList?.totalTryitTeam}
            totalScratch={showRiderDataList?.totalScratch}
            totalRiders={showRiderDataList?.totalRiders}
            totalRides={showRiderDataList?.totalRides}
            totalTryitRides={showRiderDataList?.totalTryitRiders}
          />
        </CardWrapper>
        {/* Show Manage Riders Table */}
        {loading ? (
          <TableSkeletonLoader rowContent={8} width={100} headingWidth={50} />
        ) : (
          <ShowManageRiderTable
            setPageSkip={setPageSkip}
            pageSkip={pageSkip}
            debounceShowSearch={debounceShowSearch}
            fetchManageGetShowRiderList={fetchManageGetShowRiderList}
            showRiderDataList={showRiderDataList}
            deleteShowRider={deleteShowRider}
            teamId={teamId}
            onSaveClick={handleSaveClick}
            onClassDelete={handleClassDelete}
            divisionIdsArray={divisionIdsArray}
            categoryIdsArray={categoryIdsArray}
          />
        )}
      </StyledCommonPageWrapper>
    </>
  );
};

export default ShowManageRider;
const SearchButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
const CardWrapper = styled.div`
  padding-top: 10px;
`;
const StyledCommonPageWrapper = styled(CommonPageWrapper)`
  height: calc(100vh - 135px) !important;
  padding: 0px;
`;
